function fileUploadDropzone() {
	return {
		restrict: "A",
		scope: {
			onFileSelected: "&",
			setDropActive: "&",
			isDisabled: "<"
		},
		link: (scope, element) => {
			const setActive = (active) => {
				scope.$applyAsync(() => scope.setDropActive({ active }));
			};

			const dragOver = (event) => {
				if(scope.isDisabled) {
					return;
				}
				event.preventDefault();
				event.stopPropagation();
				setActive(true);
			};

			const dragLeave = (event) => {
				if(scope.isDisabled) {
					return;
				}
				event.preventDefault();
				event.stopPropagation();
				setActive(false);
			};

			const drop = (event) => {
				if(scope.isDisabled) {
					return;
				}
				event.preventDefault();
				event.stopPropagation();
				setActive(false);
				const file = event.dataTransfer?.files && event.dataTransfer.files[0];
				scope.$apply(() => scope.onFileSelected({ file }));
			};

			element.on("dragenter", dragOver);
			element.on("dragover", dragOver);
			element.on("dragleave", dragLeave);
			element.on("dragend", dragLeave);
			element.on("drop", drop);

			scope.$on("$destroy", () => {
				element.off("dragenter", dragOver);
				element.off("dragover", dragOver);
				element.off("dragleave", dragLeave);
				element.off("dragend", dragLeave);
				element.off("drop", drop);
			});
		}
	};
}

export default angular
	.module("vesl.behaviors.file-upload-dropzone", [])
	.directive("fileUploadDropzone", fileUploadDropzone).name;
